"use client";

import { useContext } from "react";
import { resolveText } from "./binding";
import { MacaronButtonInnerContext, MacaronNumericQuantityLabelContext, MacaronSelectionItemActiveContext } from "./scope";
import type { MacaronRenderContext, RecordAny } from "./types";

function variantClass(variant?: string): string {
  switch (variant) {
    case "title":
      return "font-sans text-[20px] font-semibold leading-[1.25]";
    case "bodySemibold":
      return "font-sans text-[16px] font-semibold leading-[1.63]";
    case "bodySans":
      return "font-sans text-[16px] font-normal leading-[1.63]";
    case "bodySansSemibold":
      return "font-sans text-[16px] font-semibold leading-[1.63]";
    case "subheadline":
      return "font-sans text-[14px] font-normal leading-[1.86]";
    case "subheadlineSemibold":
      return "font-sans text-[14px] font-semibold leading-[1.86]";
    case "caption":
      return "font-sans text-[12px] font-normal leading-[1.5]";
    case "captionSemibold":
      return "font-sans text-[12px] font-semibold leading-[1.5]";
    default:
      return "font-sans text-[16px] font-normal leading-[1.63]";
  }
}

function colorClass(color?: string): string {
  switch (color) {
    case "secondary":
      return "text-[#595856]";
    case "tertiary":
      return "text-[#ABAAA6]";
    default:
      return "text-[#161615]";
  }
}

function formatNumericQuantity(text: string, shouldPrefix: boolean): string {
  if (!shouldPrefix) return text;
  const trimmed = text.trim();
  return /^\d+$/.test(trimmed) ? `×${trimmed}` : text;
}

export function MacaronLabel({ config, ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  const text = resolveText(config.text, ctx.data);
  const variant = typeof config.variant === "string" ? config.variant : "";
  const color = typeof config.color === "string" ? config.color : undefined;
  const inButton = useContext(MacaronButtonInnerContext);
  const inSelectedItem = useContext(MacaronSelectionItemActiveContext);
  const shouldPrefixNumericQuantity = useContext(MacaronNumericQuantityLabelContext);
  const displayText = formatNumericQuantity(text, shouldPrefixNumericQuantity);
  return <div className={`${variantClass(variant)} ${inSelectedItem ? "text-[#8CA62A]" : colorClass(color)} ${inButton ? "" : "whitespace-pre-line"}`}>{displayText}</div>;
}
